//import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
//import "./ie11/all";
//import 'babel-polyfill';
//import 'react-app-polyfill/ie11';
import 'core-js/es/set'
import 'core-js/es/map'
//import "babel-polyfill";
import React from 'react';
import {hydrate} from 'react-dom';
import './assets/styles/main.css';
import {createStore, applyMiddleware} from "redux";
import reducer from "./reducers";
import thunk from 'redux-thunk'
import {createLogger} from 'redux-logger'
import {Provider} from 'react-redux'
import {HashRouter} from "react-router-dom";
import App from "./App";
const middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
}

//console.log = () => {};

let store = createStore(reducer, applyMiddleware(...middleware));

hydrate(
    <Provider store={store}>
        <HashRouter hashType={"noslash"}>
            <App/>
        </HashRouter>
    </Provider>,
    document.getElementById('vitra-appointment')
);